import Page from "webPage/Page";
import $ from "jquery";
import Ajax from "base/Ajax";
import GlobalEvents from "base/GlobalEvents";
import VideoHelper from "video/VideoHelper";

Page.register('/stories/?$', function () {

    let loadRequest;

    $("body").on("click", ".js-watch-video", function () {
        let $modal = $(".js-video-modal");
        let $modalContent = $modal.find(".js-modal-content");

        let $story = $(this).parents(".stories");

        let $video = eotwJSXFactory('div');

        let $wrap = eotwJSXFactory('div', {class: "video__wrapper video__wrapper--loading", style: $story.find(".video__wrapper").attr("style")}, [$video]);
        $modalContent.html($wrap);

        let player = VideoHelper.process($story.attr("data-provider"), $story.attr("data-video-id"), $video, {autoplay: true});

        player.on("loaded", () => {
            $wrap.addClass("video__wrapper--playing");
        });
        let fn = () => {
            GlobalEvents.off('website.modal.close', fn);
            player.destroy();
        };
        GlobalEvents.on('website.modal.close', fn);

        $("body").addClass("modal-active");
        $modal.addClass("modal--active");

        return false;
    }).on("click", ".js-read-more", function () {

        let $modal = $(".js-read-more-modal");
        let id = $(this).parents(".stories").attr("data-id");

        $("body").addClass("modal-active");
        $modal.addClass("modal--active");
        if ($modal.attr("data-id") === id) {
            return false;
        }

        if (loadRequest) loadRequest.abort();

        let $modalContent = $modal.find(".js-modal-content");
        $modalContent.html(
            eotwJSXFactory('span', {class: "article-list__loader article-list__loader--show"}, [
                eotwJSXFactory('span', {class: "article-list__loader-icon"})
            ])
        );
        $modal.attr("data-id", id);
        Ajax.get("content", "235d8e2255a15ec7/posts/" + id, {}, Ajax.WEBSITE).then((data) => {
            $modalContent.html(
                (
                    eotwJSXFactory('div', {class: "modal__scroll"}, [

                        eotwJSXFactory('div', {class: "modal__header"}, [
                            eotwJSXFactory('h5', {unsafeHtml: data.activeRevision.values.title})
                        ])
                    ])
                ).append(data.activeRevision.values.content)
            ).append()
        }).catch((e) => {
            console.error(e);
            $modalContent.html("Couldn't load the content");
        });
        return false;
    });

});
